<nb-card accent="danger">
  <nb-card-header class="header-card">{{ titleMessage }}</nb-card-header>
  <nb-card-body>
    <div class="row container">
      <div class="d-flex justify-content-center">
        {{ message }}
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="row d-flex justify-content-between">
    <div class="mr-auto p-2">
      <button type="button" class="btn btn-danger" (click)="keepBuying()"> {{ okMessage }} </button>
    </div>
    <div class="p-2">
      <button type="button" class="btn btn-secondary" (click)="close(false)"> {{ cancelMessage }} </button>
    </div>
  </nb-card-footer>
</nb-card>
